import apiClient from 'Src/utils/apiClient';
import {
  GET, FAIL, START, SUCCESS,
} from 'Src/constants';
// import {setToken} from 'Src/actions/auth';

export default store => next => async (action) => {
  if (!action.callApi) return next(action);
  const {
    type, payload, callApi, method = GET, redirectTo, preserveQuery, params, ...rest
  } = action;
  const { dispatch, getState } = store;
  const { auth = {} } = getState();
  const { 'access-token': accessToken, uid, client } = auth;

  dispatch({
    type: type + START,
    payload,
    ...rest,
  });

  try {
    const response = await apiClient.request({
      url: callApi,
      params,
      data: { ...payload },
      method,
      headers: { 'access-token': accessToken, uid, client },
    });
    dispatch({
      type: type + SUCCESS, payload, response, ...rest,
    });
  } catch (error) {
    dispatch({
      type: type + FAIL, payload, error, ...rest,
    });
  }
  return next;
};
